/*
 * @description: 
 * @Author: 唐伟
 * @Creat: 2019-06-14 16:25:38
 * @lastTime     : 2020-01-15 11:47:56
 * @LastAuthor   : WE1ZHANTA0
 */
/**
 * Created by 长老 on 2018/09/07.
 * 公共方法类
 */
function YunJi() {

}

// 判断对象是否为空
const isEmptyObj = obj => !obj || JSON.stringify(obj) === '{}' || obj === '{}'

// 和app通讯 旧规则
const callApp = ({ key, params = {} }) => {
  // 判断数据是否对象
  const isObject = (obj) => {
    const type = Object.prototype.toString.call(obj)
    return type === '[object Object]'
  }
  const paramsArray = []
  Object.keys(params).forEach((v) => {
    if (isObject(params[v])) {
      params[v] = JSON.stringify(params[v])
    }
    paramsArray.push(`${v}=${params[v]}`)
  })
  if (paramsArray.length > 0) {
    key += (key.search(/\?/) === -1 ? '?' : '&') + paramsArray.join('&')
  }
  window.location.href = key
}

YunJi.prototype = {
  appUA: '', // app传过来的UserAgent,
  
  // basePath:"//t.yunjiweidian.com/yunjispecialbuyer",
  basePath: `//${window.location.host}/yunjispecialbuyer`,
  weixinInfo: { // 微信分享相关的信息
    title: '',
    desc: '',
    imgUrl: '',
    shareLink: ''
  },
  isEmptyObj,
  getUserAgent: function () {
    const appUA = navigator.userAgent // app的UserAgent信息
    if (appUA && appUA.indexOf('{"appVersion') != -1) {
      this.appUA = JSON.parse(appUA.substring(appUA.indexOf('{')))
    }
  },
  VCONSOLE_URL: 'https://static.yunjiglobal.com/qnUpload/frontend/js/vconsole.min.js',
  /**
   * 加载单个外部js文件
   */
  loadSingleScript: function (src, callback) {
    const s = document.createElement('script')
    s.async = false
    s.src = src
    s.addEventListener('load', () => {
      callback()
    }, false)
    document.body.appendChild(s)
  },
  // 更新链接上的时间戳
  updateUrl(url, key) {
    var key = `${key || 'nowtime'}=` // 默认是"t"
    const reg = new RegExp(`${key}\\d+`) // 正则：t=1472286066028
    const timestamp = +new Date()
    if (url.indexOf(key) > -1) { // 有时间戳，直接更新
      return url.replace(reg, key + timestamp)
    } // 没有时间戳，加上时间戳
    if (url.indexOf('\?') > -1) {
      const urlArr = url.split('\?')
      if (urlArr[1]) {
        return `${urlArr[0]}?${key}${timestamp}&${urlArr[1]}`
      }
      return `${urlArr[0]}?${key}${timestamp}`
    }
    if (url.indexOf('#') > -1) {
      return `${url.split('#')[0]}?${key}${timestamp}${location.hash}`
    }
    return `${url}?${key}${timestamp}`
  },
  // 传入时间是否是今天
  timeIsInTodayRange(time) {
    var pred = new Date(Date.now())
    var d = new Date(Date.now() + 24 * 60 * 60 * 1000 + 8 * 3600 * 1000)
    var predTime = new Date(pred.getUTCFullYear(), pred.getUTCMonth(), pred.getUTCDate(), 0, 0, 0, 0).getTime()
    var dTime = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), 0, 0, 0, 0).getTime()
    return time < dTime && time > predTime
  },
  /**
   * rem转成px
   */
  remToPx: function (remNum) {
    const rootFontSize = Number.parseFloat(document.documentElement.style.fontSize)
    return remNum * rootFontSize
  },
  /**
   * 转换时间格式(兼容ios浏览器)
   * 用法：format(ms,'yyyy-MM-dd hh:mm:ss')
   * @param time 毫秒数
   * @param fmt 要转换的时间格式
   */
  formatNew: function (time, fmt) {
    if (typeof time == 'string' && time.constructor == String) {
      time = time.toString().replace(/-/g, '/')
    }
    const d = new Date(Number(time))
    const o = {
      'M+': d.getMonth() + 1, // 月份
      'd+': d.getDate(), // 日
      'h+': d.getHours(), // 小时
      'm+': d.getMinutes(), // 分
      's+': d.getSeconds(), // 秒
      'q+': Math.floor((d.getMonth() + 3) / 3), // 季度
      S: d.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (`${d.getFullYear()}`).substr(4 - RegExp.$1.length)) }
    for (const k in o) { if (new RegExp(`(${k})`).test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : ((`00${o[k]}`).substr((`${o[k]}`).length))) }
    return fmt
  },
  getLimitTime: function (t) {
    let month = 0, 
      d = 0, 
      h = 0, 
      m = 0, 
      str = ''
    const newTime = new Date(t)
    month = newTime.getMonth() + 1
    d = newTime.getDate()
    h = newTime.getHours()
    m = newTime.getMinutes()
    str += `${month}月${d}日  ${this.parseDate(h)}:${this.parseDate(m)}`
    return str
  },
  /**
   * 获取url参数
   * @param param 参数名
   * @returns {*}
   */
  getUrlParams: function (param) {
    const ps = decodeURI(location.href)
    if (ps == '') return ''
    const params = (ps.substr(ps.lastIndexOf('?') + 1)).split('&')
    if (params != null) {
      for (let i = 0; i < params.length; i++) {
        const strs = params[i].split('=')
        if (strs[0] == param && strs[1] && strs[1] !== 'undefined') {
          return strs[1]
        }
      }
    }
    return ''
  },
  entityToUrl(obj, noQue = false) {
    return Object.keys(obj).reduce((o, k) => o += `${o || noQue ? '&' : '?'}${k}=${obj[k]}`, '')
  },
  /**
   * 删除url参数
   * @param name 参数名
   * @returns url
   */
  delUrlParams: function (name) {
    const href = location.href
    let base = href.split('?')[0]
    const query = href.split('?')[1]
    if (!query) {
      return href
    }
    if (query.indexOf(name) > -1) {
      const obj = {}
      const arr = query.split('&')
      for (let i = 0; i < arr.length; i++) {
        arr[i] = arr[i].split('=')
        obj[arr[i][0]] = arr[i][1]
      }
      delete obj[name]
      if (JSON.stringify(obj) != '{}') {
        base += '?'
      }
      const url = base + JSON.stringify(obj).replace(/[\"\{\}]/g, '').replace(/\:/g, '=').replace(/\,/g, '&')
      return url
    } 
    return href
  },
  /**
   * 替换url参数
   * @param name 参数名
   * @returns url
   */
  repUrlParams: function (key, value) {
    const href = location.href
    let base = href.split('?')[0]
    const query = href.split('?')[1]
    if (!query) {
      return href
    }
    if (query.indexOf(key) > -1) {
      const obj = {}
      const arr = query.split('&')
      for (let i = 0; i < arr.length; i++) {
        arr[i] = arr[i].split('=')
        obj[arr[i][0]] = arr[i][1]
      }
      obj[key] = value
      if (JSON.stringify(obj) != '{}') {
        base += '?'
      }
      const url = base + JSON.stringify(obj).replace(/[\"\{\}]/g, '').replace(/\:/g, '=').replace(/\,/g, '&')
      return url
    } 
    return href
  },
  getAppIdForH5() {
    var _appUA = navigator.userAgent; //app的UserAgent信息
    if (_appUA && _appUA.indexOf('{"appVersion') != -1) {
      return JSON.parse(_appUA.substring(_appUA.indexOf("{"))).appIdForH5;
    }
  },
  // 监听页面显示 或者 隐藏 --小程序或者H5中
  checkH5PageShowOrHide(cb,ctx) {
    let visibilityChange = ''
    if (typeof document.hidden !== 'undefined') { // Opera 12.10 and Firefox 18 and later support 
      visibilityChange = 'visibilitychange'
    } else if (typeof document.msHidden !== 'undefined') {
      visibilityChange = 'msvisibilitychange'
    } else if (typeof document.webkitHidden !== 'undefined') {
      visibilityChange = 'webkitvisibilitychange'
    }
    document.addEventListener(visibilityChange, () => {
      cb && cb.apply(document.hidden, ctx)
    }, false)
  },
  /**
   * 设备类型
   */
  getPhoneType() {
    let result = false
    const u = navigator.userAgent
    if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) { // 安卓手机
      result = false
    } else if (u.indexOf('iPhone') > -1) { // 苹果手机
      result = true
    } else if (u.indexOf('Windows Phone') > -1) { // winphone手机
      result = false
    } else if (u.indexOf('iPhone Simulator') > -1) {
      result = true
    }
    return result
  },
  /**
   * 转换时间格式的过滤器
   * 用法：
   * times = 1489895605000
   * {{times | filterFormatDate('yyyy-MM-dd hh:mm:ss')}}
   * @param time 毫秒数
   * @param fmt 要转换的时间格式
   */
  filterFormatDate: function (time, fmt) {
    if (!time) {
      return
    }
    const d = new Date(Number(time))
    const o = {
      'M+': d.getMonth() + 1, // 月份
      'd+': d.getDate(), // 日
      'h+': d.getHours(), // 小时
      'm+': d.getMinutes(), // 分
      's+': d.getSeconds(), // 秒
      'q+': Math.floor((d.getMonth() + 3) / 3), // 季度
      S: d.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (`${d.getFullYear()}`).substr(4 - RegExp.$1.length)) }
    for (const k in o) { if (new RegExp(`(${k})`).test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : ((`00${o[k]}`).substr((`${o[k]}`).length))) }
    return fmt
  },
  /**
   * 转换活动开始时间的过滤
   * 用法：
   * times = 1489895605000
   * {{filterFormatDate()}}
   * @param time 毫秒数
   */
  filterFormatTime: function (time) {
    const d = new Date(Number(time))
    console.log(d)
    const o = {
      M: d.getMonth() + 1, // 月份
      d: d.getDate(), // 日
      h: d.getHours(), // 小时
      m: d.getMinutes() // 分
    }
    return `${o.M}月${o.d}日 ${o.h}：${o.m}`
  },
  /**
   * 格式化倒计时
   * @param time 时间戳
   * return [[0,0], [0,0], [0,0], [1]]
   */
  formatCountDown: function (time) {
    let h = 0, 
      m = 0, 
      s = 0, 
      ms = 0
    if (time >= 0) {
      h = Math.floor(time / 1000 / 60 / 60)
      m = Math.floor(time / 1000 / 60 % 60)
      s = Math.floor(time / 1000 % 60)
      ms = Math.floor(time % 1000)
    }
    h = this.parseDate(h).toString().split('')
    m = this.parseDate(m).toString().split('')
    s = this.parseDate(s).toString().split('')
    ms = [Math.floor(ms / 100)]
    return {
      h: h,
      m: m,
      s: s,
      ms: ms
    }
  },
  formatTimePeriod(faultDate, completeTime) {
    const intervalTime = (completeTime - faultDate) / 1000
    const hour = parseInt(intervalTime / 3600)
    const minute = parseInt((intervalTime - hour * 3600) / 60)
    const second = parseInt(intervalTime - hour * 3600 - minute * 60)
    return {
      h: hour < 10 ? `0${hour}` : hour,
      m: minute < 10 ? `0${minute}` : minute,
      s: second < 10 ? `0${second}` : second
    }
  },
  /**
   * 获取倒计时
   * @param t 毫秒数的时间戳
   * @param fmt 转换的时间格式 “dd hh:mm:ss”或者”dd hh:mm“
   * @returns {string}
   */
  getSurplus: function (t, fmt) {
    var fmt = fmt || 'dd hh:mm:ss'
    let d = 0, 
      h = 0, 
      m = 0, 
      s = 0, 
      str = ''
    if (t >= 0) {
      d = Math.floor(t / 1000 / 60 / 60 / 24)
      h = Math.floor(t / 1000 / 60 / 60 % 24)
      m = Math.floor(t / 1000 / 60 % 60)
      s = Math.floor(t / 1000 % 60)
    }
    switch (fmt) {
      case 'hh:mm:ss':
        h = d * 24 + h
        if (h > 0) {
          str = `${this.parseDate(h)}:`
        } else {
          str = '00:'
        }
        str = `${str + this.parseDate(m)}:${this.parseDate(s)}`
        break
      case 'h:m:s':
        h = d * 24 + h
        if (h > 0) {
          str = `${this.parseDate(h)}时`
        }
        str = `${str + this.parseDate(m)}分${this.parseDate(s)}秒`
        break
      case 'dd hh:mm:ss': // 天 时分秒
        str += `${d}天${this.parseDate(h)}:${this.parseDate(m)}:${this.parseDate(s)}`
        break
      case 'dd hh:mm:ss n': // 天 时分秒
        str += this.showNewStr(d, h, m, s)
        break
      case 'dd hh:mm:ss m': // 天 时分秒 (倒计时长大于24小时，展示天/时/分/秒，倒计时小于等于24小时，展示时/分/秒)
        str += this.showNewS(d, h, m, s)
        break
      case 'd h:m:s': // 天 时:分:秒
        str += `${d}:${this.parseDate(h)}:${this.parseDate(m)}:${this.parseDate(s)}`
        break
      case 'dd hh:mm': // 天 时分
        str += `${d}天${this.parseDate(h)}时${this.parseDate(m)}分`
        break
      case 'h:m': // 时:分
        str += `${this.parseDate(h)}:${this.parseDate(m)}`
        break
      case 'dd h:m:s': // 剩天时分秒
        str += this.showStr(d, h, m, s)
        break
      case 'h:m:s': // 剩时分秒
        str += this.showStr(d, h, m, s)
        break
      case 'mm:ss': // 还剩 分秒
        str += this.showStr(d, h, m, s)
        break
      case 'm:s': // 分秒
        if (m == 0) {
          if (s == 0) {
            str += ''
          } else {
            str += `00:${this.parseDate(s)}`
          }
        } else {
          str += `${this.parseDate(m)}:${this.parseDate(s)}`
        }
        break
      case 'm:s n': // 分秒
        if (m == 0) {
          if (s == 0) {
            str += ''
          } else {
            str += `0分${this.parseDate(s)}秒`
          }
        } else {
          str += `${this.parseDate(m)}分${this.parseDate(s)}秒`
        }
        break
      case 'hh':
        var hours = d * 24
        str += (hours + parseInt(this.parseDate(h)))
        break
      case 'mm':
        str += this.parseDate(m)
        break
      case 'ss':
        str += this.parseDate(s)
        break
      case 'dd hh:mm:ss k': // 天 时分秒 (时长大于24小时，展示天/时/分/秒，倒计时小于等于24小时，展示时/分/秒 ,倒计时小于等于1小时，展示分/秒)
        str += this.showNewK(d, h, m, s)
        break
    }
    return str
  },
  /**
   * 将小于10的数字前加一个0
   * @param t 需要转换的数字
   * @returns 返回转换过的数字
   */
  parseDate: function (t) {
    return t < 10 ? `0${t}` : t
  },
  /**
   * 设置某个缓存
   * @param key 缓存名称
   * @param value 缓存值
   */
  setStorage: function (key, value) {
    key = key.replace(/\//g, '_')
    if (value === undefined) return
    localStorage.setItem(key, JSON.stringify(value))
  },
  /**
   * 获取某个缓存
   * @param key 通过缓存名称
   */
  getStorage: function (key) {
    key = key.replace(/\//g, '_')
    return JSON.parse(localStorage.getItem(key))
  },
  /**
   * 清除某个缓存
   * @param key 通过缓存名称
   */
  removeStorage: function (key) {
    key = key.replace(/\//g, '_')
    localStorage.removeItem(key)
  },
  /**
   * 清除所有缓存
   */
  clearStorage: function () {
    localStorage.clear()
  },

  /**
   * 设置session某个缓存
   * @param key 缓存名称
   * @param value 缓存值
   */
  setSessionStorage: function (key, value) {
    key = key.replace(/\//g, '_')
    if (value === undefined) return
    sessionStorage.setItem(key, JSON.stringify(value))
  },
  /**
   * 获取session某个缓存
   * @param key 通过缓存名称
   */
  getSessionStorage: function (key) {
    key = key.replace(/\//g, '_')
    return JSON.parse(sessionStorage.getItem(key))
  },
  /**
   * 清除session某个缓存
   * @param key 通过缓存名称
   */
  removeSessionStorage: function (key) {
    key = key.replace(/\//g, '_')
    sessionStorage.removeItem(key)
  },
  /**
   * 清除session所有缓存
   */
  clearSessionStorage: function () {
    sessionStorage.clear()
  },
  /**
   * 设置页面标题
   */
  setDocumentTitle: function (title) {
    setTimeout(() => {
      // 利用iframe的onload事件刷新页面
      document.title = title
      const iframe = document.createElement('iframe')
      iframe.src = '//static.yunjiglobal.com/qnUpload/frontend/logo/favicon.ico' // 必须
      iframe.style.visibility = 'hidden'
      iframe.style.width = '1px'
      iframe.style.height = '1px'
      iframe.onload = function () {
        setTimeout(() => {
          document.body.removeChild(iframe)
        }, 0)
      }
      document.body.appendChild(iframe)
    }, 0)
  },
  /**
   * 截取字符串
   * @param str 需要截取的字符串
   * @param len 截取的长度
   * return str 截取后的字符串
   */
  cutStr(str, len) {
    let str_length = 0
    let str_len = 0
    let str_cut = new String()
    str_len = str.length
    for (let i = 0; i < str_len; i++) {
      const a = str.charAt(i)
      str_length++
      if (escape(a).length > 4) {
        // 中文字符的长度经编码之后大于4
        str_length++
      }
      str_cut = str_cut.concat(a)
      if (str_length > len) {
        str_cut = str_cut.substring(0, str_cut.length - 1).concat('...')
        return str_cut
      }
    }
    // 如果给定字符串小于等于指定长度，则返回源字符串；
    if (str_length <= len) {
      return str
    }
  },
  /**
   * 是否是微信浏览器，true代表是微信浏览器
   */
  isWeiXin() {
    const ua = window.navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true
    } 
    return false
  },
  /**
   * 获取cookie的函数
   */
  getCookie(cookieName) {
    const strCookie = document.cookie
    const arrCookie = strCookie.split('; ')
    for (let i = 0; i < arrCookie.length; i++) {
      const arr = arrCookie[i].split('=')
      if (cookieName == arr[0]) {
        return arr[1]
      }
    }
    return ''
  },
  // 设置 setCookie
  setCookie(key, val, time) {
    const date = new Date() // 获取当前时间
    const expiresDays = time // 将date设置为n天以后的时间
    date.setTime(date.getTime() + expiresDays * 24 * 3600 * 1000) // 格式化为cookie识别的时间
    const hostList = window.location.host.split('.')
    document.cookie = `${key}=${val};expires=${time == -1 ? -1 : date.toGMTString()};path=/;domain=${hostList[1]}.${hostList[2]};` // 设置cookie
  },
  //清除cookie
  clearCookie(key) {
    this.setCookie(key, '', -1)
  },
  // 是否跨境商品
  isCrossBorder(itemChannel) {
    if (itemChannel == 3 || itemChannel == 4 || itemChannel == 5 || itemChannel == 6 || itemChannel == 7 || itemChannel == 8 || itemChannel == 9 || itemChannel == 10 || itemChannel == 11 || itemChannel == 12 || itemChannel == 13) {
      return true
    } 
    return false
  },
  /**
  *   app唤起登陆
  */
  appLoginLocationHref() {
    location.href = 'yunji://shop/shopDetail/shopping?appCont=2'
  },
  wxLoginLocationHref() {
    document.location.reload()
  },
  frontAddZero(d) {
    if (d < 10) {
      return `0${d}`
    }
    return d
  },
  // 节流函数
  throttle(fn, delay) {
    // now:当前的时间; lastExec:上次执行的时间; timer: 记录timeout的id; context: fn执行的上下文作用域；args:函数执行传递的参数
    let now, 
      lastExec, 
      timer, 
      context, 
      args
    // scroll回调函数真正执行的核心函数
    const execute = function () {
      fn.apply(context, args)
      lastExec = now
    }
    // 闭包函数(绑定到scroll事件上的回调函数)
    return function () {
      context = this
      args = arguments
      now = Date.now()
      if (timer) {
        clearTimeout(timer)
        timer = null
      }
      if (lastExec) {
        // 判断是否超过指定时间间隔，超过则执行
        const diff = delay - (now - lastExec)
        if (diff < 0) {
          execute()
        } else {
          timer = setTimeout(() => {
            execute()
          }, diff)
        }
      } else {
        execute()
      }
    }
  },
  /**
   * 加法
   */
  add(arg1, arg2) {
    let r1, 
      r2, 
      m, 
      c
    try {
      r1 = arg1.toString().split('.')[1].length
    } catch (e) {
      r1 = 0
    }
    try {
      r2 = arg2.toString().split('.')[1].length
    } catch (e) {
      r2 = 0
    }
    c = Math.abs(r1 - r2)
    m = Math.pow(10, Math.max(r1, r2))
    if (c > 0) {
      const cm = Math.pow(10, c)
      if (r1 > r2) {
        arg1 = Number(arg1.toString().replace('.', ''))
        arg2 = Number(arg2.toString().replace('.', '')) * cm
      } else {
        arg1 = Number(arg1.toString().replace('.', '')) * cm
        arg2 = Number(arg2.toString().replace('.', ''))
      }
    } else {
      arg1 = Number(arg1.toString().replace('.', ''))
      arg2 = Number(arg2.toString().replace('.', ''))
    }
    return (arg1 + arg2) / m
  },
  // 减法
  sub(arg1, arg2) {
    let r1, 
      r2, 
      m, 
      n
    try {
      r1 = arg1.toString().split('.')[1].length
    } catch (e) {
      r1 = 0
    }
    try {
      r2 = arg2.toString().split('.')[1].length
    } catch (e) {
      r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2)) // last modify by deeka //动态控制精度长度
    n = (r1 >= r2) ? r1 : r2
    return Number(((arg1 * m - arg2 * m) / m).toFixed(n))
  },
  // 乘法
  mul(arg1, arg2) {
    let m = 0,
      s1 = arg1.toString(),
      s2 = arg2.toString()
    try {
      m += s1.split('.')[1].length
    } catch (e) {}
    try {
      m += s2.split('.')[1].length
    } catch (e) {}
    return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
  },
  // 除法
  div(arg1, arg2) {
    let t1 = 0,
      t2 = 0,
      r1, 
      r2
    try {
      t1 = arg1.toString().split('.')[1].length
    } catch (e) {}
    try {
      t2 = arg2.toString().split('.')[1].length
    } catch (e) {}
    r1 = Number(arg1.toString().replace('.', ''))
    r2 = Number(arg2.toString().replace('.', ''))
    return (r1 / r2) * Math.pow(10, t2 - t1)
  },
  thinkingReportSetConsumerID(fc) {
    if (this.isApp()) { // 在app中不用获取consumer_id
      fc && fc()
    } else {
      var timer = setInterval(() => {
        const consumer_id = YunJi.getCookie('burial_point_cid')
        if (consumer_id) {
          thinkingReport.setPageProperty({ consumer_id: consumer_id })
          fc && fc()
          clearInterval(timer)
        }
      }, 300)
    }
  },
  /**
   * 是否是app，true代表是app版本
   */
  isApp() {
    const appCont = YunJi.getUrlParams('appCont') || 0 // H5、app
    if (appCont == 1 || appCont == 2 || YunJi.appUA) {
      return true
    } 
    return false
  },
  /**
   * 调用app内部方法
   * eg:appCommonRule('20181224','reportLoadingCompletedJs',['1','2'])
   * 版本号日期，方法名，数组格式的参数
   * @param callback 回调传入app方法返回的值
   */
  appCommonRule(appIdForH5, methodName, value, callback) {
    const appCont = YunJi.getUrlParams('appCont') || 0
    let backValue
    if ((parseInt(appCont) == 1 || parseInt(appCont) == 2) && YunJi.appUA && YunJi.appUA.appIdForH5 >= appIdForH5) {
      if (typeof (window.yjapp) != 'undefined' && typeof window.yjapp[methodName] == 'function') {
        if (value == undefined) {
          backValue = window.yjapp[methodName]()
          // backValue = eval(`window.yjapp.${methodName}()`)
        } else if (Object.prototype.toString.call(value) === '[object Object]' || Object.prototype.toString.call(value) === '[object Array]') {
          // eslint-disable-next-line no-undef
          backValue = yjapp[methodName](JSON.stringify(value))          
        } else {
          backValue = window.yjapp[methodName](value)
          // backValue = eval(`window.yjapp.${methodName}(${value})`)
        }
        backValue && callback && callback(backValue)
      }
    }
  },
  // appCommonRule(appIdForH5, methodName, value, callback) {
  //   const appCont = Number(YunJi.getUrlParams('appCont')) || 0
  //   let backValue
  //   if ((appCont === 1 || appCont === 2) && YunJi.appUA && YunJi.appUA.appIdForH5 >= appIdForH5) {
  //     if (methodName.startsWith('yunji') || methodName.includes('itemdetail.xhtml')) {
  //       // 旧规则
  //       callApp({
  //         key: methodName,
  //         params: value
  //       })
  //     } else if (YunJi.appUA.appIdForH5 >= '20190419' && YunJi.appUA.useWkWeb === '1') {
  //       // ios wk内核
  //       if (isEmptyObj(value)) {
  //         try { window.webkit.messageHandlers[methodName].postMessage(null) } catch (e) {
  //           // continue regardless of error
  //         }
  //       } else {
  //         try { window.webkit.messageHandlers[methodName].postMessage(value) } catch (e) {
  //           // continue regardless of error
  //         }
  //       }
  //     } else if (typeof (window.yjapp) !== 'undefined' && typeof window.yjapp[methodName] === 'function') {
  //       // ios 非wk内核
  //       if (value === undefined) {
  //         backValue = window.yjapp[methodName]()
  //       } else if (Object.prototype.toString.call(value) === '[object Object]' || Object.prototype.toString.call(value) === '[object Array]') {
  //         backValue = window.yjapp[methodName](JSON.stringify(value))
  //       } else {
  //         backValue = window.yjapp[methodName](value)
  //       }
  //       // eslint-disable-next-line no-unused-expressions
  //       backValue && callback && callback(backValue)
  //     } else if (!YunJi.getPhoneType()) {
  //       // 安卓新规则
  //       // eslint-disable-next-line no-alert
  //       prompt(JSON.stringify({ methodName, value }))
  //     }
  //   }
  // },
  /**
  * 新的调用app内部方法 iOS内核优化后版本
  * eg:newAppCommonRule('20181224','reportLoadingCompletedJs',{params:params,fun:'fun'})
  * window.webkit.messageHandlers.methodName.postMessage({a:1,b:2,func:''})
  * @param callback 回调传入app方法返回的值
  */
  newAppCommonRule(appIdForH5, methodName, value) {
    const appCont = Number(YunJi.getUrlParams('appCont')) || 0
    let nowAppIdForH5 = ''
    if (YunJi.appUA) {
      nowAppIdForH5 = YunJi.appUA.appIdForH5
      if ((appCont === 1 || appCont === 2) && (nowAppIdForH5 >= appIdForH5)) {
        if (JSON.stringify(value) === '{}' || value === undefined || value === '') {
          try {
            if (!YunJi.getPhoneType()) {
              // 安卓新规则
              // eslint-disable-next-line no-alert
              // prompt(JSON.stringify({ methodName, value }))
              // eslint-disable-next-line no-alert
              // prompt(methodName)
              window.yjapp[methodName](JSON.stringify(value))
            } else {
              window.webkit.messageHandlers[methodName].postMessage(null)
            }
          } catch (e) {
            console.log(e)
          }
        } else {
          try {
            if (!YunJi.getPhoneType()) {
              // 安卓新规则
              // eslint-disable-next-line no-alert
              // prompt(methodName)
              window.yjapp[methodName](JSON.stringify(value))
            } else {
              window.webkit.messageHandlers[methodName].postMessage(value)
            }
          } catch (e) {
            console.log(e)
          }
        }
      }
    }  
  },

  /**
  * app低版本手机规则调用
  * eg:{methodName:'reportLoadingCompletedJs',value:['1','2']}
  */
  appRule(methodName, value) {
    // prompt(`{methodName:${methodName},value:${value}}`)
  },
   /**
    * 是否是ios系统
    */
   isIOS() {
    return navigator.userAgent.match(/iphone|ipod|ipad/gi);
  },
   //  是否是安卓
  isAndroid(){
    return /android/i.test(navigator.userAgent.toLowerCase());
  },
  /**
   * 设置用户登录的cookie，只有非微信浏览器
   * qq、微博浏览器，或者其他浏览器登录成功才存在此cookie信息
   */
  setJPCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var str = window.location.host.split(".")[1] + "." + window.location.host.split(".")[2];
    document.cookie = cname + "=" + escape(cvalue) + ";expires=" + d.toGMTString() + ";path=/;domain=" + str + ";";
  },
  // 是否是iphoneX 系列手机   
  isIphoneXall() {
    // iPhone X、iPhone XS
    const isIPhoneX = /iphone/gi.test(window.navigator.userAgent) && window.screen.width === 375 && window.screen.height === 812
    // iPhone XS Max
    const isIPhoneXSMax = /iphone/gi.test(window.navigator.userAgent) && window.screen.width === 414 && window.screen.height === 896
    // iPhone XR
    const isIPhoneXR = /iphone/gi.test(window.navigator.userAgent) && window.screen.width === 414 && window.screen.height === 896
    if (isIPhoneX || isIPhoneXSMax || isIPhoneXR) {
      return true
    }
    return false    
  },
  isProd() {
    return window.location.hostname.search(/(local.|v.|t.|txst.|lb-tx.|ys-txst.|special-al-dev-tmp.|t-do-dev.)/) < 0
  }
  /**
  * app生命周期监听，20190123版本增加
  */
//  appLifeMonitor(){
//     window.onStart = this.onStart.bind(this);
//     window.onStop = this.onStop.bind(this);
//   },
}

export default YunJi = new YunJi()

if (YunJi.getPhoneType()) {
  const _sort = Array.prototype.sort
  Array.prototype.sort = function (fn) {
    if (!!fn && typeof fn === 'function') {
      if (this.length < 2) return this
      let i = 0, 
        j = i + 1, 
        l = this.length, 
        tmp, 
        r = false, 
        t = 0
      for (; i < l; i++) {
        for (j = i + 1; j < l; j++) {
          t = fn.call(this, this[i], this[j])
          r = (typeof t === 'number' ? t : t ? 1 : 0) > 0
          if (r) {
            tmp = this[i]
            this[i] = this[j]
            this[j] = tmp
          }
        }
      }
      return this
    } 
    return _sort.call(this)
  }
}
